module.exports = __webpack_public_path__ + "00_cheeks.b95dd33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer3/00_cheeks.png
// module id = rTBq
// module chunks = 0